<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm8 md8>
            <v-card style="border: 1px solid black" class="pa-3">
              <v-layout row>
                <EditClientAddress @update="updateData($event)" />
                <!-- <v-flex xs10>
                  <h3 class="headline">Billing Information</h3>
                  <p class="text-white">
                    Ebrahim Mia
                    <br />
                    TA-31, Wakil Tower Badda Link Road, Dhaka Bangladesh
                  </p>
                </v-flex>
                <v-flex xs2 class="d-flex justify-end">
                  <v-btn
                    outline
                    small
                    fab
                    color="indigo"
                    style="max-width: 41px"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </v-card>
            <v-card style="border: 1px solid black" class="pa-3 mt-4">
              <div>
                <h3 class="headline mb-1">Payment Method</h3>
                <v-select
                  :items="items"
                  label="Select Option"
                  solo
                  @change="chooseOption($event)"
                ></v-select>
              </div>
              <div v-if="choose_option == 2">
                <v-radio-group v-model="column">
                  <v-radio
                    v-for="(radio, n) in radios"
                    :key="n"
                    :label="`${radio.name}`"
                    :value="radio.value"
                    @change="clickRadio(radio.value)"
                  ></v-radio>
                </v-radio-group>
              </div>
              <div v-else>
                <v-radio-group>
                  <v-radio label="Pay Later" value="blue"></v-radio>
                </v-radio-group>
              </div>

              <v-layout row>
                <v-flex xs12>
                  <v-btn color="success" block @click="payNow">Pay Now</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-card class="pa-3 ml-4 grey lighten-4" flat>
              <h3 class="headline" align="center">Payment Details</h3>
              <div class="mt-3">
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader>Project ID</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>{{ budget.project_id }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader>Total Budget</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>{{ budget.total_budget_amount }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader>Minimum Payable Amount</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>{{ budget.min_payable_amount }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  v-if="choose_option == 2 && editedItem.payment_status_id != 6"
                >
                  <v-flex xs8>
                    <v-subheader>Paid Amount</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>{{ budget.paid_amount }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  v-if="choose_option == 2 && editedItem.payment_status_id != 6"
                >
                  <v-flex xs8>
                    <v-subheader>Remaining Payment</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>{{ remaining_payment }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="choose_option == 2">
                  <v-flex xs8>
                    <v-subheader>Enter Your Expected Amount</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="editedItem.paid_amount"
                      type="number"
                      placeholder="Enter Amount"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="700px">
          <v-card v-if="this.payment_method_id == 1">
            <v-card-title class="indigo">
              <div><span class="headline">Bkash Payment</span></div>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container grid-list-md>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Transaction ID:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.transaction_id"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Transaction ID"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Bkash Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.account_number"
                        :rules="phoneRules"
                        type="number"
                        placeholder="Bkash number"
                        box
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Amount:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.paid_amount"
                        readonly
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Date:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="190px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.trasanction_date"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="YYY-MM-DD format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.trasanction_date"
                          :min="new Date().toISOString().substr(0, 10)"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Time:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.trasanction_time"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="H:M format"
                            readonly
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="editedItem.trasanction_time"
                          full-width
                          @click:minute="$refs.menu.save(time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Page Photo:
                      </v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <BkashImageUpload
                        @change="onImageChange($event)"
                        select-text="Select file"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn class="error text-none" flat @click="close">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="success text-none"
                flat
                @click="submit"
                :disabled="clicked"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else-if="this.payment_method_id == 2">
            <v-card-title class="indigo">
              <div><span class="headline">Nagad Payment</span></div>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container grid-list-md>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Transaction ID:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.transaction_id"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Transaction ID"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Nagad Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.account_number"
                        :rules="phoneRules"
                        type="number"
                        placeholder="Nagad number"
                        box
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Amount:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.paid_amount"
                        readonly
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Date:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="190px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.trasanction_date"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="YYY-MM-DD format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.trasanction_date"
                          :min="new Date().toISOString().substr(0, 10)"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Time:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.trasanction_time"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="H:M format"
                            readonly
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="editedItem.trasanction_time"
                          full-width
                          @click:minute="$refs.menu.save(time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Page Photo:
                      </v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <BkashImageUpload
                        @change="onImageChange($event)"
                        select-text="Select file"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn class="error text-none" flat @click="close">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="success text-none"
                flat
                @click="submit"
                :disabled="clicked"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else-if="this.payment_method_id == 3">
            <v-card-title class="indigo">
              <div><span class="headline">Cheque Payment</span></div>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container grid-list-md>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Cheque Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.transaction_id"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Cheque number"
                        type="number"
                        box
                      ></v-text-field>
                      <v-subheader class="black--text">Bank Name:</v-subheader>
                      <v-text-field
                        v-model="editedItem.bank_name"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Bank name"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Account Name:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.account_name"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Account name"
                        box
                      ></v-text-field>
                      <v-subheader class="black--text">
                        Account Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.account_number"
                        :rules="[(v) => !!v || 'This field is required!']"
                        type="number"
                        placeholder="Account number"
                        box
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Amount:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.paid_amount"
                        readonly
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Cheque Received Date:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="190px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.cheque_receive_date"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="YYY-MM-DD format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.cheque_receive_date"
                          :min="new Date().toISOString().substr(0, 10)"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Cheque Deposited Date:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="190px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.cheque_deposit_date"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="YYY-MM-DD format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.cheque_deposit_date"
                          :min="new Date().toISOString().substr(0, 10)"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Cheque Documents:
                      </v-subheader>
                    </v-flex>
                    <v-flex xs4 offset-sm2>
                      <v-subheader class="black--text">
                        Deposit Documents:
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <ChequeImageUpload
                        @change="chequeImageUpload($event)"
                        select-text="Select file"
                      />
                    </v-flex>
                    <v-flex xs4 offset-sm2>
                      <ChequeDepositImage
                        @change="chequeDepositSlipUpload($event)"
                        select-text="Select file"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn class="error text-none" flat @click="close">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="success text-none"
                flat
                @click="submit"
                :disabled="clicked"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else-if="this.payment_method_id == 4">
            <v-card-title class="indigo">
              <div><span class="headline">BEFTN Payment</span></div>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Transaction ID:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.transaction_id"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Transaction id"
                        box
                      ></v-text-field>
                      <v-subheader class="black--text">Bank Name:</v-subheader>
                      <v-text-field
                        v-model="editedItem.bank_name"
                        :rules="[(v) => !!v || 'This field is required!']"
                        placeholder="Bank name"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text">
                        Account Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.account_number"
                        :rules="[(v) => !!v || 'This field is required!']"
                        type="number"
                        placeholder="Account number"
                        box
                      ></v-text-field>
                      <v-subheader class="black--text">
                        Routing Number:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.beftn_routing_number"
                        :rules="[(v) => !!v || 'This field is required!']"
                        type="number"
                        placeholder="Account number"
                        box
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Amount:
                      </v-subheader>
                      <v-text-field
                        v-model="editedItem.paid_amount"
                        readonly
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Date:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="190px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.trasanction_date"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="YYY-MM-DD format"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.trasanction_date"
                          :min="new Date().toISOString().substr(0, 10)"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="black--text">
                        Transaction Time:
                      </v-subheader>
                      <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.trasanction_time"
                            :rules="[(v) => !!v || 'This field is required!']"
                            placeholder="H:M format"
                            readonly
                            v-on="on"
                            box
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="editedItem.trasanction_time"
                          full-width
                          @click:minute="$refs.menu.save(time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn class="error text-none" flat @click="close">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="success text-none"
                flat
                @click="submit"
                :disabled="clicked"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { EditClientAddress } from "@/components/index";
  import { BkashImageUpload } from "@/components/index";
  import { ChequeImageUpload } from "@/components/index";
  import { ChequeDepositImage } from "@/components/index";
  export default {
    components: {
      EditClientAddress,
      BkashImageUpload,
      ChequeImageUpload,
      ChequeDepositImage,
    },
    data() {
      return {
        valid: true,
        dialog: false,
        clicked: false,
        apiUrl: "client-pay",
        editedIndex: -1,
        menu1: false,
        menu2: false,
        date: null,
        time: null,
        total_budget: "",
        perSurveyCost: "",
        payment_method_id: null,
        remaining_payment: "",
        editedItem: {
          project_id: "",
          transaction_id: "",
          paid_amount: "",
          beftn_routing_number: "",
          trasanction_date: "",
          trasanction_time: "",
          transaction_photo: "",
          payment_method_id: "",
          payment_status_id: "",
          account_name: "",
          bank_name: "",
          account_number: "",
          cheque_receive_date: "",
          cheque_deposit_date: "",
          cheque_photo: "",
          deposit_slip_photo: "",
        },
        defaultItem: {
          project_id: "",
          transaction_id: "",
          paid_amount: "",
          beftn_routing_number: "",
          trasanction_date: "",
          trasanction_time: "",
          transaction_photo: "",
          payment_method_id: "",
          payment_status_id: "",
          account_name: "",
          bank_name: "",
          account_number: "",
          cheque_receive_date: "",
          cheque_deposit_date: "",
          cheque_photo: "",
          deposit_slip_photo: "",
        },
        items: [
          "Pay Later",
          "Pay Option",
          //   { name: "Pay Later", value: 1 },
          //   { name: "Pay Option", value: 2 },
        ],
        paymentMethod: {
          pay_later: 0,
          pay_method: 0,
        },
        choose_option: 0,
        column: null,
        radios: [
          { name: "bKash", value: 1 },
          { name: "Nagad", value: 2 },
          { name: "Cheque", value: 3 },
          { name: "BEFTN", value: 4 },
          { name: "Payment Getway", value: 5 },
        ],
        budget: {
          project_id: "",
          total_budget_amount: "",
          min_payable_amount: "",
          paid_amount: "",
          payment_method_id: "",
          total_budget_coins: "",
        },
        client: {
          address: null,
        },
        phoneRules: [
          (v) => !!v || "Phone is required",
          (v) => (v && v.length == 11) || "Should be 11 digits.",
        ],
      };
    },

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let id = localStorage.getItem("projectId");
        this.$store.dispatch("paymentPage", ["payment", id]);
        this.budget.project_id = this.indexData.datas.id;
        this.budget.total_budget_amount = this.indexData.datas.grand_total;
        this.budget.min_payable_amount = this.indexData.datas.payable_amount;
        this.budget.paid_amount = this.indexData.datas.paid_amount;
        this.editedItem.project_id = this.indexData.datas.id;
        this.editedItem.payment_status_id =
          this.indexData.datas.payment_status_id;
        this.remaining_payment =
          this.indexData.datas.grand_total - this.indexData.datas.paid_amount;
      },

      save(date) {
        this.$refs.menu.save(date);
        this.menu1 = false;
      },

      onImageChange(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.transaction_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      chequeImageUpload(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.cheque_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      chequeDepositSlipUpload(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.deposit_slip_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      
      paymentGateway() {
        // console.log(this.budget)
        alert("Currently it is not active, Please choose another option!");
        // this.budget.total_budget_amount = this.indexData.datas.grand_total;
        // this.budget.total_budget_coins = this.indexData.datas.grand_total * 10;
        // this.budget.per_survey_cost_coins =
        //   this.indexData.datas.per_survey_cost * 10;
        // if (this.editedIndex > -1) {
        //   this.$store.dispatch("storePayment", [this.apiUrl, this.budget]);
        //   // this.clicked = true
        // } else {
        //   this.$store.dispatch("storePayment", [this.apiUrl, this.budget]);
        //   // this.clicked = true
        // }
      },
      bkash() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 1;
          this.editedItem.payment_method_id = 1;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      nagad() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 2;
          this.editedItem.payment_method_id = 2;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      cheque() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 3;
          this.editedItem.payment_method_id = 3;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      beftn() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 4;
          this.editedItem.payment_method_id = 4;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      chooseOption(event) {
        if (event === "Pay Later") {
          this.choose_option = 1;
        } else {
          this.choose_option = 2;
        }
      },

      clickRadio(event) {
        this.payment_method_id = event;
      },

      close() {
        this.dialog = false;
        this.payment_method_id = null;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      submit() {
        if (this.$refs.form.validate()) {
          // console.log(this.editedItem);
          this.$store.dispatch("newTransaction", [
            "transaction",
            this.editedItem,
          ]);
          this.clicked = true;
        }
      },

      updateData(event) {
        this.client.address = event.address;
        // console.log(event);
      },

      payNow() {
        if (this.choose_option == 1) {
          if (this.client.address == null) {
            alert("Your billing address should not be null");
          } else {
            this.budget.payment_method_id = 0;
            var popUpMsg = confirm("Are you sure you want to pay later?");
            if (popUpMsg) {
              // console.log(this.budget);
              // this.$store.dispatch("newTransaction", ["transaction", this.budget]);
            }
          }
        } else if (this.choose_option == 2) {
          if (this.client.address == null) {
            alert("Your billing address should not be null!");
          } else {
            if (this.payment_method_id == 1) {
              this.bkash();
            } else if (this.payment_method_id == 2) {
              this.nagad();
            } else if (this.payment_method_id == 3) {
              this.beftn();
            } else if (this.payment_method_id == 4) {
              this.cheque();
            } else if (this.payment_method_id == 5) {
              this.paymentGateway();
            } else {
              alert("Please choose any payment method!");
            }
          }
        } else {
          alert("Please select any payment option!");
        }
      },
    },
  };
</script>

<style>
  .flex_border {
    border-color: black !important;
  }
</style>
